import { render, staticRenderFns } from "./dialog-preview-file.vue?vue&type=template&id=5ce14688&scoped=true"
import script from "./dialog-preview-file.vue?vue&type=script&lang=js"
export * from "./dialog-preview-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce14688",
  null
  
)

export default component.exports